import React from "react";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import skilledge from "../../assets/skilledge/skilledage.png";

const SkillEdge = () => {
    const images = [
        { image: "https://i.ibb.co/qMK64Ks/skilledge1.png" },
        {
            image: "https://i.ibb.co/T1TxDrN/skilledge2.png",
        },
        {
            image: "https://i.ibb.co/mS7sZfr/skilledge3.png",
        },
        {
            image: "https://i.ibb.co/QJC0djk/skilledge4.png",
        },
    ];
    return (
        <div>
            <img src={skilledge} className="w-full" alt="website" />
            <div className="w-full px-4 md:px-10 lg:p-0 lg:w-4/5 mx-auto flex justify-center items-center lg:items-start flex-col lg:flex-row mt-8 text-justify dark:text-[#E9F8F9]">
                <div className="w-full lg:w-[80%] lg:pr-8">
                    <h3 className="font-bold text-xl">Description</h3>
                    <div className="mt-5">
                        <h4>
                            ShuterUp is a full stack single photographer service
                            provider website.
                        </h4>
                        <ul className="list-disc ml-5 mt-3">
                            <li className="mb-2">
                                Users can create there account with email
                                password login, github login, google login and
                                it is created by firebase authentication.
                            </li>
                            <li className="mb-2">
                                If users not login they cannot buy any
                                course.When they click If users not login they
                                cannot buy any course.When they click "Go to
                                Premium" button then redirect login page and
                                after login redirect Premium Course page.
                            </li>
                            <li className="mb-2">
                                User can download course details with pdf
                                format.
                            </li>
                            <li className="mb-2">
                                Premium course is a protected route.
                            </li>
                            <li className="mb-2">
                                Review route is protected by JWT.
                            </li>
                        </ul>
                    </div>
                    {/* <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
                        <img src={regameDetails1} alt="" />
                        <img src={regameDetails2} alt="" />
                        <img src={regameDetails3} alt="" />
                        <img src={regameDetails4} alt="" />
                    </div> */}
                    <Swiper
                        className="mt-8 w-96 md:w-10/12 cursor-grab"
                        modules={[Pagination]}
                        spaceBetween={40}
                        slidesPerView={1}
                        pagination={{ clickable: true }}
                    >
                        {images.map((photo, id) => (
                            <SwiperSlide className="rounded-lg" key={id}>
                                <img
                                    className="rounded-lg pb-10"
                                    src={photo.image}
                                    alt=""
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <h3 className="font-bold text-xl">Technologies Used</h3>
                    <div className="mt-5">
                        <ul className="list-disc ml-5 mt-3">
                            <li className="mb-2">React.js</li>
                            <li className="mb-2">React Boostrap</li>
                            <li className="mb-2">react-to-print</li>
                            <li className="mb-2">Firebase</li>
                            <li className="mb-2">Node.js</li>
                            <li className="mb-2">MondoDb</li>
                            <li className="mb-2">Express.js</li>
                            <li className="mb-2">React Router Dom</li>
                        </ul>
                    </div>
                </div>

                <div className="w-full my-8 lg:mt-0 lg:w-1/4 lg:pr-5">
                    <h3 className="font-bold text-xl">Details</h3>

                    <div>
                        <h4 className="font-semibold mt-3">Live Site</h4>
                        <a
                            href="https://skill-edge-248cf.web.app/"
                            rel="noreferrer"
                            target="_blank"
                        >
                            SkillEdge
                        </a>
                    </div>

                    <div>
                        <h4 className="font-semibold mt-3">Client Side Code</h4>
                        <a
                            href="https://github.com/nabilAhmedN/skill-edge"
                            rel="noreferrer"
                            target="_blank"
                        >
                            ./<span className="underline">nabilAhmedN</span>/
                            <span className="underline">
                                <span className="underline">skillEdge</span>
                            </span>
                        </a>
                    </div>

                    <div>
                        <h4 className="font-semibold mt-3">Server Side Code</h4>
                        <a
                            href="https://github.com/nabilAhmedN/skill-edge-server"
                            rel="noreferrer"
                            target="_blank"
                        >
                            ./<span className="underline">nabilAhmedN</span>/
                            <span className="underline">skillEdge-server</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkillEdge;
